import * as React from 'react';
import { PureComponent } from 'react';
import { AppContext, AppContextType } from '../../AppContextType';
import { SharingProps } from './SharingProps';

export class Print extends PureComponent<SharingProps> {
    public static contextType = AppContextType;
    public context: AppContext = {} as AppContext;
    
    public render() {
        const titleAttribute = this.context.i18n.translate('Drucken');

        return <div className="jc-share-link">
            <button className="discreet" title={titleAttribute} onClick={window.print}>
                <i className="far fa-print"/>
            </button>
        </div>;
    }
}
